import colors from "../Constants/colors";
import { HealthInfo } from "../Models/monitoring";

export const getGradeText = (grade: number): string => {
  switch (true) {
    case grade >= 90:
      return "gradeText.exemplaryCoverage";
    case grade >= 80:
      return "gradeText.extensiveInformation";
    case grade >= 70:
      return "gradeText.adequateInformation";
    case grade >= 60:
      return "gradeText.partialInformation";
    case grade >= 40:
      return "gradeText.sparseInformation";
    case grade > 0:
      return "gradeText.verySparseInformation";
    default:
      return "gradeText.noInformationAvailable";
  }
};

export const getGradeColor = (grade: number) => {
  if (grade >= 80)
    return {
      color: colors.green700,
      bgcolor: colors.green50,
      borderColor: colors.green200,
    };
  if (grade >= 50)
    return {
      color: colors.blue700,
      bgcolor: colors.blue50,
      borderColor: colors.blue200,
    };
  if (grade >= 30)
    return {
      color: colors.yellow700,
      bgcolor: colors.yellow50,
      borderColor: colors.yellow200,
    };
  return {
    color: colors.red700,
    bgcolor: colors.red50,
    borderColor: colors.red200,
  };
};

export const getHealthInfo = (percentage: number): HealthInfo => {
  if (percentage <= 50) {
    return {
      label: "Healthy",
      color: colors.green700,
      bgColor: colors.green50,
      barColor: colors.green700,
    };
  }
  if (percentage <= 75) {
    return {
      label: "Moderate",
      color: colors.yellow700,
      bgColor: colors.yellow50,
      barColor: colors.yellow700,
    };
  }
  if (percentage <= 90) {
    return {
      label: "At Risk",
      color: colors.orange600,
      bgColor: colors.orange50,
      barColor: colors.orange600,
    };
  }
  return {
    label: "Critical",
    color: colors.red600,
    bgColor: colors.red50,
    barColor: colors.red600,
  };
};
